<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Lonesome Rider and Wilde Imaginings</span></p>
<p class="subtitle"><span>Two Romantic Novellas</span></p>
<p class="authorname"><span>Heather Graham</span></p>
<p class="publisher"><span><img alt="image" src="images/fig_02.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?477cc310